import { NavLink } from 'react-router-dom';
import { ADMIN_NAV_LINKS } from '../../lib/constants';
import styles from './AdminSidebar.module.css';

export function AdminSidebar() {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <span className={styles.brandName}>HubWire</span>
        <span className={styles.brandSub}>Admin</span>
      </div>

      <nav className={styles.nav} aria-label="Admin navigation">
        {ADMIN_NAV_LINKS.map((link) => (
          <NavLink
            key={link.path}
            to={link.path}
            end={link.path === '/admin'}
            className={({ isActive }) =>
              [styles.navLink, isActive ? styles.active : ''].join(' ')
            }
          >
            {link.label}
          </NavLink>
        ))}
      </nav>

      <div className={styles.footer}>
        <NavLink to="/" className={styles.viewSite} target="_blank">
          View Public Site ↗
        </NavLink>
      </div>
    </aside>
  );
}
